var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.496,
    height: 18.972,
    viewBox: "0 0 14.496 18.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#fff;stroke-width:1.5px;stroke-linecap:round}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(-1161.714 -108.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(1148.772 97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_924",
    "data-name": "Rectangle 924",
    style: {
      stroke: "#fff",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v11a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V0z",
    style: {
      stroke: "none"
    },
    transform: "translate(13.228 16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5.75h11a.75.75 0 0 1 .75.75V11A2.25 2.25 0 0 1 11 13.25H3A2.25 2.25 0 0 1 .75 11V1.5A.75.75 0 0 1 1.5.75z",
    style: {
      fill: "none"
    },
    transform: "translate(13.228 16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(13.692 11.778)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_66",
    "data-name": "Line 66",
    className: "cls-2",
    transform: "translate(0 2.905)",
    d: "M0 0h12.996"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M0-.224V-3.13h6.5v2.906",
    transform: "translate(3.249 3.13)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#fff",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_68",
    "data-name": "Line 68",
    className: "cls-2",
    transform: "translate(1167.106 118.181)",
    d: "M0 0v5.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_69",
    "data-name": "Line 69",
    className: "cls-2",
    transform: "translate(1170.819 118.181)",
    d: "M0 0v5.57"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.dcae3578.svg";
export { ForwardRef as ReactComponent };